import { Directive, TemplateRef, ViewContainerRef, Input, ElementRef, Renderer, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';

import { Lab } from '../../contracts/lab/lab.model';
import { LabGuard } from './lab-guard.service';

@Directive({
  selector: '[mcLabGuard]'
})
export class LabGuardDirective implements OnInit {
  @select(['labState', 'currentLab']) currentLab$: Observable<Lab>;
  private hideIfLabExpired = false;

  constructor(private el: ElementRef, private renderer: Renderer,
    private labGuardService: LabGuard) {
  }

  ngOnInit() {
    this.currentLab$.subscribe((currentLab) => {
      if (!this.hideIfLabExpired || currentLab && this.labGuardService.hasAccessToLabIfExpired(currentLab)) {
        this.renderer.setElementStyle(this.el.nativeElement, 'display', '');
      } else {
        this.renderer.setElementStyle(this.el.nativeElement, 'display', 'none');
      }
    });
  }

  @Input() set mcLabGuard(considerExpirationState: boolean) {
    this.hideIfLabExpired = considerExpirationState;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/guards/lab-guard.directive.ts